import React, { FC, useState } from 'react'
import { fetchMyCollections, postMyCollectionsCreate } from "apis/private/collection";
import CollectionConnector, { ConnectorProps as CollectionProps } from 'connectors/Collection'
import CollectionForm from '../Form/Create'

type Props = CollectionProps & {
  setCollections: (payload: Record<string, any>[]) => any
  artworkId?: number
  closeModal: () => void
  onSuccess?: (payload: Record<string, any>, formData: Record<string, any>) => void
}

const CreateCollectionsContent: FC<Props> = (props) => {
  const { setCollections, addMessage, closeModal, isAdmin, isCollector, isArtist, onSuccess } = props
  const [isSubmitting, handleIsSubmitting] = useState(false)

  return (
    <CollectionForm
      isAdmin={isAdmin}
      isCollector={isCollector}
      isArtist={isArtist}
      isSubmitting={isSubmitting}
      closeModal={closeModal}
      createCollection={async (formData) => {
        handleIsSubmitting(true)
        const { success, payload } = await postMyCollectionsCreate(formData)

        if (!success) {
          addMessage({
            messages: ['Problem creating collection'],
            type: 'error',
          })
          handleIsSubmitting(false)
          return
        }

        addMessage({
          messages: ['New Collection Created. Browse art to add to your collection.'],
          type: 'success',
        })

        const myCollections = await fetchMyCollections()

        if (myCollections.type === 'error') {
          addMessage(myCollections)
          return
        }

        setCollections(myCollections.payload)

        if (onSuccess) {
          onSuccess(payload, formData)
        }

        handleIsSubmitting(false)
        closeModal()
      }}
    />
  )
}

export default CollectionConnector(CreateCollectionsContent)
